/*!
 * timedata.js - time management for bcoin
 * Copyright (c) 2014-2015, Fedor Indutny (MIT License)
 * Copyright (c) 2014-2017, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcoin
 */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var EventEmitter = require('events');

var util = require('../utils/util');

var binary = require('../utils/binary');
/**
 * Time Data
 * An object which handles "adjusted time". This may not
 * look it, but this is actually a semi-consensus-critical
 * piece of code. It handles version packets from peers
 * and calculates what to offset our system clock's time by.
 * @alias module:protocol.TimeData
 * @extends EventEmitter
 * @property {Array} samples
 * @property {Object} known
 * @property {Number} limit
 * @property {Number} offset
 */


var TimeData = /*#__PURE__*/function (_EventEmitter) {
  _inherits(TimeData, _EventEmitter);

  var _super = _createSuper(TimeData);

  /**
   * Create time data.
   * @constructor
   * @param {Number} [limit=200]
   */
  function TimeData(limit) {
    var _this;

    _classCallCheck(this, TimeData);

    _this = _super.call(this);
    if (limit == null) limit = 200;
    _this.samples = [];
    _this.known = new Map();
    _this.limit = limit;
    _this.offset = 0;
    _this.checked = false;
    return _this;
  }
  /**
   * Add time data.
   * @param {String} id
   * @param {Number} time
   */


  _createClass(TimeData, [{
    key: "add",
    value: function add(id, time) {
      if (this.samples.length >= this.limit) return;
      if (this.known.has(id)) return;
      var sample = time - util.now();
      this.known.set(id, sample);
      binary.insert(this.samples, sample, compare);
      this.emit('sample', sample, this.samples.length);

      if (this.samples.length >= 5 && this.samples.length % 2 === 1) {
        var median = this.samples[this.samples.length >>> 1];

        if (Math.abs(median) >= 70 * 60) {
          if (!this.checked) {
            var match = false;

            var _iterator = _createForOfIteratorHelper(this.samples),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var offset = _step.value;

                if (offset !== 0 && Math.abs(offset) < 5 * 60) {
                  match = true;
                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            if (!match) {
              this.checked = true;
              this.emit('mismatch');
            }
          }

          median = 0;
        }

        this.offset = median;
        this.emit('offset', this.offset);
      }
    }
    /**
     * Get the current adjusted time.
     * @returns {Number} Adjusted Time.
     */

  }, {
    key: "now",
    value: function now() {
      return util.now() + this.offset;
    }
    /**
     * Adjust a timestamp.
     * @param {Number} time
     * @returns {Number} Adjusted Time.
     */

  }, {
    key: "adjust",
    value: function adjust(time) {
      return time + this.offset;
    }
    /**
     * Unadjust a timestamp.
     * @param {Number} time
     * @returns {Number} Local Time.
     */

  }, {
    key: "local",
    value: function local(time) {
      return time - this.offset;
    }
    /**
     * Get the current adjusted time in milliseconds.
     * @returns {Number} Adjusted Time.
     */

  }, {
    key: "ms",
    value: function ms() {
      return Date.now() + this.offset * 1000;
    }
  }]);

  return TimeData;
}(EventEmitter);
/*
 * Helpers
 */


function compare(a, b) {
  return a - b;
}
/*
 * Expose
 */


module.exports = TimeData;